export default {
  init() {
    // JavaScript to be fired on all pages


    /**
     * Check if the zone matches the location code.
     * - Ranged (1234...2345)
     * - Wildcards (200*, 30** etc.)
     * - Normal (1234)
     *
     * @param {string|int} postcode
     * @param {}
     */
    window.checkZoneLocationCode = function (postcode, zoneLocationCode) {
      postcode = parseInt(postcode);

      let regExp = new RegExp(/^\d+\.{3}\d+$/i);

      // Check match if the code is ranged (1234...2345)
      if (zoneLocationCode.match(regExp)) {
        let zoneLocationCodeRange = zoneLocationCode.split('...');

        if (postcode >= parseInt(zoneLocationCodeRange[0]) && postcode <= parseInt(zoneLocationCodeRange[1]))
        return true;
      }

      // Check match if the code has wildcards
      if (zoneLocationCode.includes('*')) {
        regExp = new RegExp(`^${zoneLocationCode.replace(/\*/g, '\\d')}$`);

        if (String(postcode).match(regExp))
          return true;
      }

      // Check match if the code is normal
      return (postcode === parseInt(zoneLocationCode));
    }

    /**
     * Checks all location codes.
     * - Ranged (1234...2345)
     * - Wildcards (200*, 30** etc.)
     * - Normal (1234)
     *
     * @param {string|int} postcode
     * @param {string[]} zoneLocationCodes array of location codes
     * @param {(string|int, string) => bool} func function that checks postcode for each code
     *
     * @return {bool} true if the postcode matches any of the codes
     */
    window.checkZones = function (postcode, zoneLocationCodes, func) {
      for (let i in zoneLocationCodes) {
        if (func(postcode, zoneLocationCodes[i]))
          return true;
      }

      return false;
    };
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
